import {
  EMPLOYEE_DETAIL_FETCH,
  EMPLOYEE_DETAIL_SUCCESS,
  EMPLOYEE_DETAIL_FAILURE
} from './actionTypes';

const initialState = {
  isLoaded: false,
  error: []
};

export const employeeDetailReducer = (state = initialState, action) => {
  switch (action.type) {
    case EMPLOYEE_DETAIL_FETCH:
      return { ...state, isLoaded: false };
    case EMPLOYEE_DETAIL_SUCCESS:
      return { ...state, isLoaded: true };
    case EMPLOYEE_DETAIL_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/EmployeeDetail/reducer.js